import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import DataTable, { TableColumn } from 'react-data-table-component';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Modal,
  Row
} from 'reactstrap';
import { Button, InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { actionColumnStyles, dataTableCustomStyles } from 'src/components/Common/FixedActionColumn';
import { useAppSelector } from 'src/rtk/app/hook';
import { useGetReportListQuery, useLazyGetProgressReportDataQuery } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';
import { useGetLookupDataQuery } from 'src/rtk/features/setup/lookup/lookupDataApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import loader from '../../assets/images/loader.gif';
import { ProgressReportPDF } from './ProgressReportPDF';

const ProgressReport = () => {
  document.title = 'Progress Report | BCPS';

  const [pageShow, setPageShow] = useState(false);
  const authUser = useAppSelector((state) => state.auth.user);

  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [search, setSearch] = useState('');
  const [selectedSubject, setSelectedSubject] = useState<any>('');
  const [selectedSlotType, setSelectedSlotType] = useState<any>('');
  const [currentTraineeStatus, setCurrentTraineeStatus] = useState<boolean>(false);
  const [reportId, setReportId] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [sessionInfo, setSessionInfo] = useState<any>('');
  const [regInfo, setRegInfo] = useState<any>('');
  const [modalShow, setModalShow] = useState(false);
  const [selectedInstitue, setSelectedInstitute] = useState<any>('');

  const [selectedInstitueCategory, setSelectedInstituteCategory] = useState<any>('');
  const [selectedTraineeCategory, setSelectedTraineeCategory] = useState<any>('');
  const [selectedIncomeCategory, setSelectedIncomeCategory] = useState<any>('');

  let referenceUrl = new URLSearchParams(location.search).get('ref');

  const { data: sessionLookupData } = useGetLookupDataQuery('session');

  const allTrainingInstituteCategory: SelectOption[] = [
    { label: 'Sadar Hospital/District Hospital/Zila Hospital', value: 'Sadar Hospital/District Hospital/Zila Hospital' },
    { label: 'Government Medical College Hospital (under MoHFW)', value: 'Government Medical College Hospital (under MoHFW)' },
    { label: 'Public Medical University', value: 'Public Medical University' },
    { label: 'Government Postgraduate Medical Institute (under MoHFW)', value: 'Government Postgraduate Medical Institute (under MoHFW)' },
    { label: 'Government Institute/Hospital (under MoHFW)', value: 'Government Institute/Hospital (under MoHFW)' },
    { label: 'Government Institute/Hospital (under Ministry of Defence)', value: 'Government Institute/Hospital (under Ministry of Defence)' },
    { label: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)', value: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)' },
    { label: 'Government Hospital (under Ministry of public Administration)', value: 'Government Hospital (under Ministry of public Administration)' },
    { label: 'Non-Government Postgraduate Medical Institute/Hospital', value: 'Non-Government Postgraduate Medical Institute/Hospital' },
    { label: 'Non-Governmnet Charitable Organization', value: 'Non-Governmnet Charitable Organization' },
    { label: 'Private Medical College Hospital', value: 'Private Medical College Hospital' },
    { label: 'Private Hospital', value: 'Private Hospital' },
    { label: 'Foreign Institute/Hospital', value: 'Foreign Institute/Hospital' },
  ];

  const allTraineeCategory: SelectOption[] = [
    { label: 'Trainees receiving allowances in government institutions', value: 'Trainees receiving allowances in government institutions' },
    { label: 'Trainees receiving allowances by private institutions', value: 'Trainees receiving allowances by private institutions' },
    { label: 'Trainees in government employment', value: 'Trainees in government employment' },
    { label: 'Trainees in private employment', value: 'Trainees in private employment' },
  ];

  const allIncomeCategory: SelectOption[] = [
    { label: 'Yes, involvement in Job/Income generating activities', value: 'Yes' },
    { label: 'No, not involvement in Job/Income generating activities', value: 'No' },
  ];

  const sessionList: SelectOption[] =
    (sessionLookupData as any)?.data[0]?.childs?.map((item: any) => ({
      value: item.name,
      label: item.name,
    })) || [];

  const currentYear = new Date().getFullYear();
  const startYear = 2025;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }

  const allYears: SelectOption[] = years?.map((item: any) => ({
    value: item,
    label: item,
  })) || [];

  const instituteList: SelectOption[] =
    useGetOrganizationsQuery()
      .data?.data?.map((item) => ({
        value: item.id!,
        label: item.organization_name!,
      }))
      .sort((a, b) => {
        return a.label.localeCompare(b.label);
      }) || [];

  const generateQueryUrl = () => {
    return `page=${page}&per_page=${limit}${search}`;
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setLimit(newPerPage);
    setPage(page);
  };

  const {
    data: reportList,
    isLoading,
    isSuccess,
    error,
    isFetching,
    refetch,
  } = useGetReportListQuery(generateQueryUrl());

  useEffect(() => {
    refetch();
  }, [referenceUrl]);

  const data: any = reportList?.data?.data || [];

  // console.log(data);

  const [getProgressReportData, { data: list }] = useLazyGetProgressReportDataQuery();

  useEffect(() => {
    if (modalShow) {
      getProgressReportData(regInfo?.registration_no);
    }
  }, [modalShow]);

  const sessionNameList = list?.data || [];
  // console.log(sessionNameList);

  const err = error as CustomError;
  interface SearchFields {
    search?: string;
    bmdc_registration_no?: string;
    subject?: string;
    slot_type?: string;
    current_trainee?: number;
    fcps_part_one_passing_session?: string;
    fcps_part_one_passing_year?: string;
    institute_id?: string;
    evaluation_status?: string;
    evaluated_from_date?: string;
    evaluated_to_date?: string;
    training_institute_type?: string;
    trainee_category?: string;
    income_category?: string;
  }

  const searchInitialValues: SearchFields = {
    search: '',
    bmdc_registration_no: '',
    subject: '',
    slot_type: '',
    current_trainee: 0,
    fcps_part_one_passing_session: '',
    fcps_part_one_passing_year: '',
    institute_id: '',
    evaluation_status: '',
    evaluated_from_date: '',
    evaluated_to_date: '',
    training_institute_type: '',
    trainee_category: '',
    income_category: '',
  };

  const { data: subjects } = useGetSubjectInfosQuery();

  const allSubjects: SelectOption[] =
    subjects?.data?.map((subject) => ({
      value: subject.subject_name,
      label: subject.subject_name,
    })) || [];

  const {
    handleSubmit: searchSubmit,
    getFieldProps: searchGetFieldProps,
    values: searchValues,
    touched,
    errors,
    setFieldValue,
    resetForm: searchResetForm,
    // setErrors,
    // isSubmitting,
  } = useFormik({
    initialValues: searchInitialValues,

    onSubmit: (searchValues) => {
      let s: string = '';

      if (searchValues.search && searchValues.search !== '') {
        s = s + `&search=${searchValues.search}`;
      }

      if (searchValues.bmdc_registration_no && searchValues.bmdc_registration_no !== '') {
        s = s + `&bmdc_registration_no=${searchValues.bmdc_registration_no}`;
      }

      if (searchValues.subject && searchValues.subject !== '') {
        s = s + `&subject=${searchValues.subject}`;
      }

      if (searchValues.slot_type && searchValues.slot_type !== '') {
        s = s + `&slot_type=${searchValues.slot_type}`;
      }

      // s = s + `&current_trainee=${searchValues.current_trainee}`

      if (searchValues.fcps_part_one_passing_session && searchValues.fcps_part_one_passing_session !== '') {
        s = s + `&fcps_part_one_passing_session=${searchValues.fcps_part_one_passing_session}`;
      }

      if (searchValues.fcps_part_one_passing_year && searchValues.fcps_part_one_passing_year !== '') {
        s = s + `&fcps_part_one_passing_year=${searchValues.fcps_part_one_passing_year}`;
      }

      if (searchValues.institute_id && searchValues.institute_id !== '') {
        s = s + `&institute_id=${searchValues.institute_id}`;
      }

      if (searchValues.evaluation_status && searchValues.evaluation_status !== '') {
        s = s + `&evaluation_status=${searchValues.evaluation_status}`;
      }

      if (searchValues.evaluated_from_date && searchValues.evaluated_from_date !== '') {
        s = s + `&evaluated_from_date=${searchValues.evaluated_from_date}`;
      }

      if (searchValues.evaluated_to_date && searchValues.evaluated_to_date !== '') {
        s = s + `&evaluated_to_date=${searchValues.evaluated_to_date}`;
      }

      if (searchValues.training_institute_type && searchValues.training_institute_type !== '') {
        s = s + `&training_institute_type=${searchValues.training_institute_type}`;
      }

      if (searchValues.trainee_category && searchValues.trainee_category !== '') {
        s = s + `&trainee_category=${searchValues.trainee_category}`;
      }

      if (searchValues.income_category && searchValues.income_category !== '') {
        s = s + `&income_category=${searchValues.income_category}`;
      }

      setSearch(s);
      setPage('1');
      // setLimit(20);
    },
  });

  const evaluationShowHandler = (pageState: boolean) => {
    setPageShow(pageState);
  }
  const modalShowHandler = (pageState: boolean, infos: any) => {
    setModalShow(pageState);
    setRegInfo(infos);
  }

  useEffect(() => {
    if (selectedSubject !== '') {
      setFieldValue('subject', selectedSubject?.value);
    }
  }, [selectedSubject]);

  useEffect(() => {
    if (selectedSlotType !== '') {
      setFieldValue('slot_type', selectedSlotType?.value);
    }
  }, [selectedSlotType]);

  useEffect(() => {
    if (currentTraineeStatus) {
      setFieldValue('current_trainee', 1);
    } else {
      setFieldValue('current_trainee', 0);
    }
  }, [currentTraineeStatus]);

  const handleCurrentTraineeStatus = (e: any) => {
    if (e.target.checked) {
      setCurrentTraineeStatus(true);
    } else {
      setCurrentTraineeStatus(false);
    }
  };

  const columns: TableColumn<any>[] = [
    {
      name: '#',
      width: '50px',
      cell: (row, index) => <strong>{((page - 1) * limit + index) + 1}</strong>,
    },

    {
      name: <div>Program Type</div>,
      selector: (row) => row?.exam_training_info?.training_type === 'Core' ? 'Core' : 'Specialty',
    },

    {
      name: <div>Slot</div>,
      width: '150px',
      selector: (row) => row?.exam_training_info?.name,
      wrap: true,
    },

    {
      name: <div>Full Name</div>,
      selector: (row) => row?.profile_info?.personal_info?.full_name,
      wrap: true,
    },

    {
      name: <div>BMDC Reg. No.</div>,
      selector: (row) => row?.profile_info?.bmdc_registration_no,
    },
    {
      name: <div>Reg. Type</div>,
      selector: (row) => row?.profile_info?.registration_type,
    },
    {
      name: <div>Subject Name</div>,
      selector: (row) => row?.profile_info?.subject?.subject_name,
      wrap: true,
    },

    {
      name: <div>Passing Session & Year</div>,
      selector: (row) => row?.profile_info?.fcps_part_one_passing_session ? row?.profile_info?.fcps_part_one_passing_session + ' - ' + row?.profile_info?.fcps_part_one_passing_year : 'N/A',
      wrap: true,
    },

    {
      name: <div>Institute</div>,
      selector: (row) =>
        row?.supervisor?.institute_name ?? 'N/A',
      wrap: true,
    },

    ...(authUser?.type === 'Operation' ? [
      {
        name: <div>Supervisor Name</div>,
        selector: (row: any) =>
          row?.supervisor?.name,
        wrap: true,
      }] : []),

    {
      name: <div>Status</div>,
      width: '150px',
      selector: (row) => row?.progress_report?.submit_status,
      cell: (row: any) => {
        switch (row?.progress_report?.submit_status) {
          case 'Submit':
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-approved font-size-12 fw-medium">
                  {'Evaluated'}
                </div>
              </>
            );

          default:
            return (
              <>
                <div className="badge rounded-pill d-inline-block badge-pending font-size-12 fw-medium">
                  {'Not Evaluated'}
                </div>
              </>
            );
        }
      },
      wrap: true,
    },

    {
      name: <div>Action</div>,
      width: '200px',
      style: actionColumnStyles,
      cell: (row, index) => (
        <div className='my-1'>
          {/* {authUser?.type === 'Operation' ?
            <button
              className="btn btn-sm btn-primary me-3"
              disabled={row?.progress_report?.submit_status !== 'Submit'}
              onClick={() => {
                modalShowHandler(true, row?.profile_info);
              }}
            >
              <span className="fas fa-eye"></span> View
            </button>
            : */}
          <button
            className="btn btn-sm btn-primary me-3"
            disabled={row?.progress_report?.submit_status !== 'Submit'}
            onClick={() => {
              setReportId(row?.id);
            }}
          >
            <span className="fas fa-eye"></span> View
          </button>
          {/* } */}
          {(reportId === row?.id) ? (
            <ProgressReportPDF
              userInfo={row?.profile_info}
              setReportId={setReportId}
              trainingId={row?.exam_training_info?.id}
              rowInfo={row}
            />
          ) : null}

          {authUser?.type === 'Supervisor' ? <Link to={{ pathname: `/performance-evaluation/${row?.profile_info?.registration_no}/${row?.supervisor?.id}/${row?.supervisor?.name}/${row?.exam_training_info?.id}/${row?.id}` }}
            className={`btn btn-danger btn-sm ${row?.progress_report?.submit_status === 'Submit' ? 'disabled' : ''}`}>
            Evaluation
          </Link> : null}
        </div>
      ),
    },
  ];

  const allStatus: SelectOption[] = [
    { value: 'evaluated', label: 'Evaluated' },
    { value: 'non_evaluated', label: 'Not Evaluated' },
  ];

  useEffect(() => {
    if (selectedInstitueCategory !== '') {
      setFieldValue('training_institute_type', selectedInstitueCategory?.value);
    }
  }, [selectedInstitueCategory]);

  useEffect(() => {
    if (selectedTraineeCategory !== '') {
      setFieldValue('trainee_category', selectedTraineeCategory?.value);
    }
  }, [selectedTraineeCategory]);

  useEffect(() => {
    if (selectedIncomeCategory !== '') {
      setFieldValue('income_category', selectedIncomeCategory?.value);
    }
  }, [selectedIncomeCategory]);

  useEffect(() => {
    if (selectedInstitue !== '') {
      setFieldValue('institute_id', selectedInstitue?.value);
    }
  }, [selectedInstitue]);

  const tableHeadersCSV = ["Sl.", "Program Type", "Slot", "Full Name", "BMDC", "Speciality", "Institute", "Year of Passing Part-1", "Supervisor", "Institute Category"];

  return (
    <div className="page-content">
      {isLoading || isFetching ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <Container fluid>
        <BetterBreadcrumb
          title="Progress Report"
          breadcrumbItem={[
            { link: '#', name: 'Monitoring' },
          ]}
        />
        <Card>
          <CardBody>
            <Row>
              <Col>
                <div className="gap-2 ">
                  <Form
                    className="custom-form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      searchSubmit();
                    }}
                  >
                    <div className="filter-wrapper mb-0">
                      <FormGroup>
                        <Label for="bmdc_registration_no">BMDC Reg. No.</Label>
                        <InputField
                          type="text"
                          placeholder="BMDC Reg. No."
                          className="form-control"
                          {...searchGetFieldProps('bmdc_registration_no')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="subject">Subject</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedSubject}
                          onChange={setSelectedSubject}
                          options={allSubjects}
                          placeholder='Select...'
                          name="subject"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="slot_type">Slot Type</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedSlotType}
                          onChange={setSelectedSlotType}
                          options={[{ label: 'Core', value: 'Core' }, { label: 'Specialty', value: 'Advance' }]}
                          placeholder='Select...'
                          name="slot_type"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="fcps_part_one_passing_session">Passing Session</Label>
                        <InputField
                          type="select"
                          placeholder="Passing Session"
                          options={sessionList}
                          {...searchGetFieldProps('fcps_part_one_passing_session')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="fcps_part_one_passing_year">Passing Year</Label>
                        <InputField
                          type="select"
                          placeholder="Passing Year"
                          options={allYears}
                          {...searchGetFieldProps('fcps_part_one_passing_year')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="institute_id">Institute</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedInstitue}
                          onChange={setSelectedInstitute}
                          options={instituteList}
                          placeholder='Institute'
                          name="institute_id"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="evaluation_status">Evaluation Status</Label>
                        <InputField
                          type="select"
                          placeholder="Evaluation Status"
                          options={allStatus}
                          {...searchGetFieldProps('evaluation_status')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="evaluated_from_date">Evaluated From Date</Label>
                        <InputField
                          type="date"
                          placeholder="Evaluated From Date"
                          {...searchGetFieldProps('evaluated_from_date')}
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="evaluated_to_date">Evaluated To Date</Label>
                        <InputField
                          type="date"
                          placeholder="Evaluated To Date"
                          {...searchGetFieldProps('evaluated_to_date')}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label className="form-label">Institute Category</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedInstitueCategory}
                          onChange={setSelectedInstituteCategory}
                          options={allTrainingInstituteCategory}
                          placeholder='Select...'
                          name="training_institute_type"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label className="form-label">Trainee Category</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedTraineeCategory}
                          onChange={setSelectedTraineeCategory}
                          options={allTraineeCategory}
                          placeholder='Select...'
                          name="trainee_category"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label className="form-label">Income Category</Label>
                        <Select
                          isClearable={true}
                          isSearchable={true}
                          value={selectedIncomeCategory}
                          onChange={setSelectedIncomeCategory}
                          options={allIncomeCategory}
                          placeholder='Select...'
                          name="income_category"
                        />
                      </FormGroup>

                      {/* <FormGroup>
                        <Label check className='form-check-label'>
                          <input
                            type="checkbox"
                            name="current_trainee"
                            id="current_trainee"
                            className="form-check-input"
                            checked={currentTraineeStatus}
                            onChange={(e) => {
                              handleCurrentTraineeStatus(e);
                            }}
                          /> Current Trainee
                        </Label>
                      </FormGroup> */}

                      <FormGroup className="btn-column mb-3">
                        <Button
                          color="danger"
                          type="reset"
                          text="Reset"
                          onClick={() => {
                            setSelectedSubject('');
                            setSelectedSlotType('');
                            setSelectedInstitute('');
                            setSelectedInstituteCategory('');
                            setCurrentTraineeStatus(false);
                            searchResetForm();
                            searchSubmit();
                          }}
                        />

                        <Button
                          type="button"
                          text="Search"
                          onClick={() => {
                            searchSubmit();
                          }}
                        />
                      </FormGroup>
                      {
                        authUser?.type === 'Operation' ? (
                          <FormGroup>
                            <CSVLink
                              headers={tableHeadersCSV}
                              data={data?.map((data: any, index: number) => [
                                ((page - 1) * limit + index) + 1,
                                data?.exam_training_info?.training_type,
                                data?.exam_training_info?.name,
                                data?.profile_info?.personal_info?.full_name,
                                data?.profile_info?.bmdc_registration_no,
                                data?.subject_name,
                                data?.profile_info?.current_session_and_supervisor_info?.supervisor?.institute_name ?? 'N/A',
                                data?.profile_info?.fcps_part_one_passing_session ? data?.profile_info?.fcps_part_one_passing_session + ' - ' + data?.profile_info?.fcps_part_one_passing_year : 'N/A',
                                data?.profile_info?.current_session_and_supervisor_info?.supervisor?.name,
                                data?.profile_info?.current_session_and_supervisor_info?.training_institute_type,
                              ]) || []}
                              filename="TraineeList.csv"
                            >
                              <Button text='Export' type="button" color='success' outline className='fw-bold' icon='fa-solid fa-file-arrow-down' />
                            </CSVLink>
                          </FormGroup>
                        ) : null
                      }
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
            <DataTable
              columns={columns}
              data={data ? data : []}
              pagination
              paginationServer
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              progressPending={isLoading}
              paginationTotalRows={reportList?.data?.total}
              expandOnRowClicked
              highlightOnHover
              paginationRowsPerPageOptions={[10, 20, 50, 100, 250, 500, 1000]}
              persistTableHead={true}
              customStyles={dataTableCustomStyles}
            />
          </CardBody>
        </Card>
      </Container>
      <Modal
        onOpened={function () {
          toast.dismiss();
        }}
        isOpen={modalShow}
        toggle={() => {
          document.body.classList.add('no_padding');
        }}
        backdrop={'static'}
        modalTransition={{ timeout: 0 }}
        backdropTransition={{ timeout: 0 }}
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Select Session
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setModalShow(!modalShow);
            }}
          ></button>
        </div>
        <div className="modal-body">
          <Row>
            <>
              <Col sm={12}>
                <table className='table table-bordered'>
                  <tbody>
                    {sessionNameList?.map((item: any) => (
                      <tr key={item.id}>
                        <td><b>{item?.session?.name}</b></td>
                        <td>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => {
                              setSessionInfo(item);
                              setSessionId(item?.id);
                            }}
                          >
                            <span className="fas fa-eye"></span> Progress Report
                          </button>
                          {/* {sessionId === item?.id ? (
                            <AdminProgressReportPDF userInfo={regInfo} sessionInfo={sessionInfo} setReportId={setSessionId} personalInfo={personalInfo?.data} />
                          ) : null} */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default ProgressReport;
